export const SPOTIFY_CLIENT_ID = "19bdec6cc05e4db6ac0c94e56325c012";
